import React from 'react';
import PropTypes from 'prop-types';

const FileInput = (props) => (
    <input type='file' multiple={props.multiple} onChange={(event) => {
        let files = event.target.files;
        if (props.multiple) {
            props.onValueChanged(files);
        } else {
            // Only send one file up or empty if no files
            let data = files.length > 0 ? files[0] : [];
            props.onValueChanged(data);
        }
    }} />
);

FileInput.propTypes = {
    onValueChanged: PropTypes.func,
    multiple: PropTypes.bool
};

FileInput.defaultProps = {
    multiple: false
};

export default FileInput;


// WEBPACK FOOTER //
// ./public/components/forms/BasicFormFields/File.jsx